


// export {ReusablePosTemplate};
/** @jsx jsx */ //please do not remove this implementation because the css will not be loaded without it
import { jsx, css } from '@emotion/react'
import React from "react";
import { dateStringTimeConvert } from "../../Utils/titleCaseFunction";
import { ItemsTable, ReceiptTemplate } from "../../Utils/Template/ReceiptTemplate";
import { textWeight, thUppercase } from "../../styles/tableStyles";
import * as colors from "../../styles/colors";
import { formatDigits } from "../../Utils/formatNumbers";
    /** @jsx jsx */

const headerCell = css`
    font-weight: bold;
    font-size: 12pt;   /* slightly bigger for thermal printers */
    text-align: left;
    color: #000;
`;

const productCell = css`
    font-weight: 600;  /* semi-bold for better clarity */
    font-size: 12pt;
`;

const totalCell = css`
    font-weight: bold;
    font-size: 14pt;
    text-align: right;
`;

const reasonCell = css`
    font-weight: bold;
    font-size: 12pt;
    color: #000;
`;
    
const titleText = css`
    margin: 0;
    color: ${colors.darkBlue001};
    font-size: 15px;
    @media print {
        font-size: 22px;
    }
`;
const tableStyle1 = css`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 5mm;
  font-size: 14pt;
  color: #000; /* dark text for all cells */

  th, td {
    padding: 1px;
    font-weight: bold; /* bold for clarity */
    text-align: left;
    color: #000; /* enforce black text */
    border: 1px solid #000; /* solid black borders */
  }

  th {
    font-size: 12pt;
    background-color: #fff; /* white background for thermal printers */
  }

  td {
    font-size: 11pt;
  }

  td.amount, td.unitPrice {
    text-align: right;
  }
`;

const tableCell = css`
    border-top: 1.4px solid ${colors.text00};
    padding-top: 16px !important;
`;

const rightPadding = css`
    padding-right: 7rem;
`;

const reasonTableCell = css`
    padding-top: 16px;
`;

const wordBreak = css`
    word-break: break-word;
`;

const headData = [
    { value: 'Product' },
    { value: 'Batch#' },
    { value: 'Qty' },
    { value: 'Price' },
    { value: 'Total' }
];

const ReusablePosTemplate = ({ customer, products, user_name ,iscompany=true}) => {
    const isInvoice = customer?.invoice_details;

    const customerDetails = (
        <>
            <tr>
                <td style={{ paddingRight: '7rem' }} css={[textWeight, thUppercase, rightPadding]}>
                    <p css={[titleText]}>Invoice To:</p>
                </td>
                <td css={[textWeight, thUppercase]}>
                    <p css={[titleText]}>Invoice Details:</p>
                </td>
            </tr>
            <tr>
                <td>Name: <span css={[textWeight]}>{customer.customer_name}</span></td>
                <td>Date: <span css={[textWeight]}>{customer.date ? dateStringTimeConvert(customer.date) : ''}</span></td>
            </tr>
            <tr>
                <td>Contact: <span css={[textWeight]}>{customer.customer_mobile}</span></td>
                <td>Invoice#: <span css={[textWeight]}>{customer.invoice_number}</span></td>
            </tr>
            <tr>
                <td>Address: <span css={[textWeight]}>{customer.customer_address}</span></td>
                <td>Account Name: <span css={[textWeight]}>{customer.account_name}</span></td>
            </tr>
        </>
    );


const tableStyle = css`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 5mm;
  font-size: 12pt;

  th, td {
    padding: 2mm 4mm;
    font-weight: bold; /* bold for clarity */
    text-align: left;
    color: #000;
  }

  th {
    font-size: 14pt;
    border-bottom: 2px solid #000; /* subtle separator for headers */
  }

  td {
    font-size: 12pt;
    border-bottom: 1px dashed #000; /* faint separator for readability */
  }

  td.amount, td.unitPrice {
    text-align: right;
  }

  tr:last-child td {
    border-bottom: none; /* avoid double lines at the end */
  }
`;
const itemDetails = (
    <>
      <table css={tableStyle1}>
        <thead>
          <tr>
            <th>Brand Name</th>
            <th>Qty</th>
            <th>Rate</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {products.map((p, index) => {
            const qty = p.quantity ? +p.quantity : 0;
            const rate = p.rate ? +p.rate : 0;
            const discount = p.discount_amount ? +p.discount_amount : 0;

            const final_rate = rate - discount;
            const total = final_rate * qty;
            return (
              <tr key={p.id}>
                <td>{p.product_name}</td>
                <td>{qty}</td>
                <td>{final_rate}</td>
                <td className="amount">{formatDigits(total)}</td>
              </tr>
            );
          })}
  
          {isInvoice && (
            <tr>
              <td colSpan="4"><strong>Reason for cancelling:</strong> {customer.invoice_details}</td>
            </tr>
          )}
  
          <tr>
            <td colSpan="2" align="right"><strong>Total Amount</strong></td>
            <td colSpan="2" className="amount"><strong>{customer.total_amount ? formatDigits(customer.total_amount) : customer.total_amount}</strong></td>
          </tr>
        </tbody>
      </table>
    </>
  );
  
    const footer = (
        <>
            <tr>
                <td align='right'>Created by: <strong>{user_name}</strong></td>
            </tr>
                {/* Christmas Message */}
              <tr>
                <td align="center" style={{ paddingTop: "10px" }}>
                   {/* Merry Christmas & Happy Holidays!                     */}
                </td>
              </tr>
            
        </>
    );

    return <ReceiptTemplate {...{ customerDetails, itemDetails, footer ,iscompany}} />;
};


export { ReusablePosTemplate };
